import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import PropTypes from 'prop-types';
// 日期美化
import { dateFormat } from '../../utils/utils';

const Content = ({ content }) => {

    const { name, url } = content;

return (
    <div className={styles.content}>
    <div className={styles.slide}>
        <ul>
            {
                content.map((item, index) => {
                
                    const { summary, newsTime, member, source, articleTag, url } = item;

                        return (
                            <li key={index} className={styles.item}>
                                <div className={styles.itemDescribe}>
                                    <a href={url} target="_blank" rel="noreferrer">{summary}</a>
                                </div>
                                <div className={styles.itemFooter}>
                                    <div className={styles.itemDate}>{dateFormat(newsTime)}</div>
                                    {
                                        articleTag ? <div className={styles.itemMember}>{articleTag}</div> : <div className={styles.itemMember}>硬核研报会员专享</div>
                                    }
                                </div>
                            </li>
                    );
                })
            }
        </ul>
    </div>
    
</div>

    );
};

Content.propTypes = {
    content: PropTypes.object,
};
export default errorBoundary(Content);
